export const EMBED_FACEBOOK_CONFIG = {
    name        : 'Facebook',
    icon        : 'i5-facebook',
    iconSvg     : 'isvg-facebook',
    description : 'Embeded Facebook',
    embedCode   : '',
    projectIcon : 'facebook',               // from ConstItemIcon and ProjectIconDictionary

    keyWords    : ['facebook.com']          // required for embedCode content search for autodetect EmbedType
}
